// Field name standardization utility
export const FIELD_NAME_MAPPING = {
  // Standard field names that should be used consistently
  'Name': ['Name', 'fullname', 'full_name', 'name', 'Name'],
  'Email': ['Email', 'email', 'email_address', 'Email Address'],
  'Company': ['Company', 'company', 'organization', 'Organization', 'employer', 'Employer'],
  'Phone': ['Phone', 'phone', 'phone_number', 'Phone Number', 'mobile', 'Mobile'],
  'Title': ['Title', 'title', 'job_title', 'Job Title', 'position', 'Position'],
  'Department': ['Department', 'department', 'dept', 'Dept'],
  'Booth': ['Booth', 'booth', 'booth_number', 'Booth Number', 'stand', 'Stand'],
  'Category': ['Category', 'category', 'type', 'Type', 'role', 'Role'],
  'ID': ['ID', 'id', 'employee_id', 'Employee ID', 'badge_id', 'Badge ID']
};

// Function to normalize field names to standard format
export const normalizeFieldName = (fieldName) => {
  if (!fieldName) return fieldName;
  
  // Check if it's already a standard field name
  if (Object.keys(FIELD_NAME_MAPPING).includes(fieldName)) {
    return fieldName;
  }
  
  // Find the standard field name for this variation
  for (const [standardName, variations] of Object.entries(FIELD_NAME_MAPPING)) {
    if (variations.includes(fieldName)) {
      return standardName;
    }
  }
  
  // If no mapping found, return the original field name
  return fieldName;
};

// Function to get field value with multiple variations
export const getFormFieldValue = (formData, fieldName) => {
  if (!formData) return 'N/A';
  
  const standardFieldName = normalizeFieldName(fieldName);
  const variations = FIELD_NAME_MAPPING[standardFieldName] || [fieldName];
  
  // Try to find the value using any of the variations
  for (const variation of variations) {
    if (formData[variation] !== undefined && formData[variation] !== null && formData[variation] !== '') {
      return formData[variation];
    }
  }
  
  return 'N/A';
};

// Function to standardize form data field names
export const standardizeFormData = (formData) => {
  if (!formData) return formData;
  
  const standardized = {};
  
  for (const [key, value] of Object.entries(formData)) {
    const standardKey = normalizeFieldName(key);
    standardized[standardKey] = value;
  }
  
  return standardized;
};

// Function to get standard field names for CSV template generation
export const getStandardFieldNames = (formSchema) => {
  if (!formSchema || !Array.isArray(formSchema)) return [];
  
  return formSchema.map(field => ({
    ...field,
    label: normalizeFieldName(field.label || field.name)
  }));
};
